import "core-js/modules/es.number.constructor.js";
import { SButton, SIcon } from '@strana-artw/ui-kit';
import { toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
export default {
  name: 'Steps',
  components: {
    SIcon: SIcon,
    SButton: SButton
  },
  props: {
    steps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentStep: {
      type: Number,
      default: 0
    }
  },
  setup: function setup() {
    var _toRefs = toRefs(useScreenPlugin()),
      md = _toRefs.md;
    return {
      md: md
    };
  },
  data: function data() {
    return {
      isMounted: false,
      isShowMenu: false
    };
  },
  mounted: function mounted() {
    this.isMounted = true;
  },
  methods: {
    checkingStep: function checkingStep(id) {
      if (this.currentStep === id) {
        return 'current';
      }
      if (this.currentStep > id) {
        return 'passed';
      }
      return 'normal';
    }
  }
};